import { render, staticRenderFns } from "./EmployeeSalaryV2.vue?vue&type=template&id=6cf97ffb&scoped=true"
import script from "./EmployeeSalaryV2.vue?vue&type=script&lang=js"
export * from "./EmployeeSalaryV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf97ffb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cf97ffb')) {
      api.createRecord('6cf97ffb', component.options)
    } else {
      api.reload('6cf97ffb', component.options)
    }
    module.hot.accept("./EmployeeSalaryV2.vue?vue&type=template&id=6cf97ffb&scoped=true", function () {
      api.rerender('6cf97ffb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/OrderKidsV2/EmployeeSalaryV2.vue"
export default component.exports